<template>
  <div>
    <div>
      <div>
        <b-table hover small caption-top fixed responsive boardered show-empty
                 id="userMgmtSearchTable"
                 :items="users"
                 :fields="userFields"
                 :per-page="perPage"
                 :current-page="currentPage"
                 :busy="busy"
                 :bordered="bordered"
                 sort-icon-left
                 selectable
                 :select-mode="selectMode"
                 selected-variant="primary"
                 @row-selected="onRowSelected"
                 style="padding: 10px"
        >
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <b-icon-check-square aria-hidden="true"></b-icon-check-square>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <b-icon-square aria-hidden="true"></b-icon-square>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>
          <template #empty="scope">
            <p>No users found.</p>
          </template>
        </b-table>
      </div>
      <div class="overflow-auto">
        <b-pagination
          v-model="currentPage"
          v-if="totalRows>0"
          :per-page="perPage"
          :total-rows="totalRows"
          :boardered="bordered"
          aria-controls="userMgmtSearchTable"
          align="fill"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
        ></b-pagination>
      </div>
      <hr>
      <div>
        <b-row cols-lg="6">
          <b-col>
            <b-button block class="lg d-block p-2 bg-mdh text-white" id="addUserButton" @click="addUser" role="button">Add user</b-button>
          </b-col>
          <b-col>
            <b-button block class="lg d-block p-2 bg-mdh text-white" id="removeUserButton" @click="removeUser" role="button">Remove user</b-button>
          </b-col>
          <b-col>
            <b-button block class="lg d-block p-2 bg-mdh text-white" id="reactivateUserButton" @click="reactivateUser" role="button">Deactivate/reactivate user</b-button>
          </b-col>
          <b-col v-if="(hasRole('mdh-admin') || hasRole('mnit-admin'))">
            <b-button block class="lg d-block p-2 bg-mdh text-white" id="editUserButton" @click="editUser" role="button">Edit user</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import userManagementAccVerify from "@/views/UserManagementAccVerify.vue";

export default {
  data: () => ({
    perPage: 10,
    currentPage: 1,
    selected: [],
    selectedName: '',
    selectMode: 'single',
    bordered: true,
    userFields: [
      'selected',
      {
        key: 'username',
        label: 'Username',
        sortable: true
      },
      {
        key: 'firstName',
        label: 'First name',
        sortable: true
      },
      {
        key: 'lastName',
        label: 'Last name',
        sortable: true
      },
      {
        key: 'email',
        sortable: true
      },
      {
        key: 'enabled',
        label: 'Is active?'
      },
      {
        key: 'group',
        label: "User role"
      }
    ],
    currentRole: '',
    roleOptions: [
      {value: 'org-user', text: 'Organization User'},
      {value: 'org-admin', text: 'Organization Administrator'},
      {value: 'mdh-admin', text: 'MDH Administrator'},
      {value: 'mnit-admin', text: 'MNIT Administrator'},
    ]
  }),

  props: {
    users: [],
    totalRows: Number,
    busy: Boolean,
    selectedFacility: Object,
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
      if (items.length !== 0) {
        this.selectedName = items[0].username
      } else {
        this.selectedName = items
      }
    },
    addUser() {
      if (this.selectedFacility !== undefined && this.selectedFacility !== "") {
        router.push("userManagementAccVerify")
      } else {
        this.showRootToast('Error','Please select a facility.','danger')
      }
    },
    removeUser() {
      if (this.selectedFacility !== undefined && this.selectedFacility !== "") {
        if (this.selected.length > 0) {
          let facilityId = this.$store.state.selectedFacility.id
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/user/removeFacility`, this.selected[0].email.toLowerCase().trim(), {params: {facilityId}})
            .then(response => {
              if (response.status === 200) {
                this.showRootToast("Success", "User has been removed from facility.", "success");
                this.$emit('refresh-list', true);
              } else {
                this.showRootToast("Error", "Error removing user from facility.", "danger");
                this.$emit('refresh-list', true);
              }
            }).catch((error) => {
            this.showRootToast('Error', 'Unable to remove user from facility at this time.', 'danger')
          })
        } else {
          this.showRootToast('Error', 'Please select a user.', 'danger')
        }
      }
    },
    reactivateUser() {
      if (this.selectedFacility !== undefined && this.selectedFacility !== "") {
        if (this.selected.length > 0) {
          if (this.selected[0].enabled === false) {
            axios.put(`${process.env.VUE_APP_API_BASE_URL}/users/${this.selected[0].id}/enable`, "true")
              .then(response => {
                if (response.status === 200) {
                  this.showRootToast("Success", "User has been reactivated.", "success");
                  this.$emit('refresh-list', true);
                }
              })
          } else {
            axios.put(`${process.env.VUE_APP_API_BASE_URL}/users/${this.selected[0].id}/enable`, "false")
              .then(response => {
                if (response.status === 200) {
                  this.showRootToast("Success", "User has been deactivated.", "success");
                  this.$emit('refresh-list', true);
                }
              })
          }
        } else {
          this.showRootToast('Error','Please select a user.','danger')
        }
      } else {
        this.showRootToast('Error','Please select a facility.','danger')
      }
    },
    editUser() {
      if (this.selectedFacility !== undefined && this.selectedFacility !== "") {
        if (this.selected.length > 0) {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/users/${this.selected[0].id}/groups`)
            .then(response => {
              if (response.status === 200) {
                this.currentRole = response.data[0].name
                router.push({name: 'userManagementEdit', params: {roles: this.currentRole, userEmail: this.selected[0].email.toLowerCase().trim()}})
              }
            })
        } else {
          this.showRootToast('Error','Please select a user.','danger')
        }
      } else {
        this.showRootToast('Error','Please select a facility.','danger')
      }
    },
    hasRole(roles) {
      if (this.$keycloak.authenticated) {
        return this.$keycloak.hasResourceRole(roles);
      } else {
        return false;
      }
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
  }
}

</script>

<style scoped>

</style>
